import * as React from 'react';
import './ItemDetails.css';
import { ItemDetail } from '../domain/SummaryData';
import formatNumber, { formatPrice } from './formatNumber';

interface Props {
    item: ItemDetail;
}

class ItemDetails extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <div className="custom-table-row">
                <div className="item-name">
                    <span>{this.props.item.name}</span>
                </div>
                <div className="item-qty">
                    <span>{formatNumber(this.props.item.quantity, 0)}</span>
                </div>
                <div className="item-price">
                    <span>{formatPrice(this.props.item.discountedPrice)}</span>
                </div>
                <div className="item-sku">
                    <div className="badge">{this.props.item.sku}</div>
                </div>
                <div className="item-subtotal">
                    <span>{formatPrice(this.props.item.subTotal)}</span>
                </div>
            </div>
        );
    }
}

export default ItemDetails;



// WEBPACK FOOTER //
// ./src/view/ItemDetails.tsx